import { Check, Sparkles } from "lucide-react";

export const PhoneMockup = () => {
  return (
    <div className="relative mx-auto w-[290px] sm:w-[330px]" data-testid="hero-phone-mockup">
      <div
        aria-hidden="true"
        className="absolute -inset-10 -z-10 rounded-full bg-splurge-primary/25 blur-3xl"
      />
      <div className="rounded-[3rem] bg-splurge-ink p-2.5 shadow-2xl shadow-splurge-dark/40">
        <img
          src="/screenshots/home.png"
          alt="Splurge app home screen showing total spent this month, weekly and daily averages, a monthly budget goal, and recent transactions"
          width="600"
          height="1299"
          className="aspect-[600/1299] w-full rounded-[2.45rem] object-cover"
        />
      </div>

      <div
        className="animate-floaty absolute -left-8 top-4 flex items-center gap-2 rounded-full bg-white py-2 pl-2.5 pr-4 shadow-xl shadow-splurge-dark/15 ring-1 ring-splurge-lavender sm:-left-14"
        data-testid="chip-group-settled"
      >
        <span className="grid h-6 w-6 place-items-center rounded-full bg-splurge-lavender">
          <Check className="h-3.5 w-3.5 text-splurge-primary" aria-hidden="true" />
        </span>
        <span className="text-xs font-bold text-splurge-ink">Group settled ✓</span>
      </div>

      <div
        className="animate-floaty-delayed absolute -right-6 bottom-24 flex items-center gap-2 rounded-full bg-splurge-ink py-2 pl-2.5 pr-4 shadow-xl shadow-splurge-dark/30 sm:-right-12"
        data-testid="chip-smarter-choice"
      >
        <span className="grid h-6 w-6 place-items-center rounded-full bg-splurge-primary/25">
          <Sparkles className="h-3.5 w-3.5 text-splurge-violet" aria-hidden="true" />
        </span>
        <span className="text-xs font-bold text-white">Smarter choice +120 pts</span>
      </div>
    </div>
  );
};
